import { render, staticRenderFns } from "./Telefoninput.vue?vue&type=template&id=f2be912e"
import script from "./Telefoninput.vue?vue&type=script&lang=js"
export * from "./Telefoninput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalFormulareTelefonBezeichnung: require('/Users/stefan/Dropbox/Stefan/gitrepos/p1ng/gnoema/frontend/components/global/formulare/TelefonBezeichnung.vue').default})
